module.exports = __webpack_public_path__ + "img/gb-nir.9cad35c4.svg";